(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__otInit) return;
      root.__otInit = true;

      var form = root.querySelector('[data-ot-form]');
      if (!form) return;
      form.addEventListener('submit', function (e) { e.preventDefault(); });

      var input = root.querySelector('[data-ot-input]');
      var hint = root.querySelector('[data-ot-hint]');
      var msg = root.querySelector('[data-ot-msg]');
      var frameBox = root.querySelector('[data-ot-frame]');
      var iframe = root.querySelector('[data-ot-iframe]');
      var openLink = root.querySelector('[data-ot-open]');
      var frameTitle = root.querySelector('[data-ot-frame-title]');
      var radios = [].slice.call(root.querySelectorAll('input[type=radio][data-url]'));
      if (!radios.length) return;

      function current() { return radios.filter(function (r) { return r.checked; })[0]; }
      function say(t, err) { msg.hidden = false; msg.textContent = t; msg.className = 'ot-msg' + (err ? ' is-error' : ''); }
      function showHint() { var c = current(); hint.textContent = c && c.dataset.hint ? c.dataset.hint : ''; }
      function closeFrame() { frameBox.hidden = true; iframe.removeAttribute('src'); }

      /* remember the last courier; allow links like /pages/track?courier=tcs&cn=123456789 */
      try { var last = localStorage.getItem('ot-courier'); radios.forEach(function (r) { if (r.value === last) r.checked = true; }); } catch (e) {}
      var params = new URLSearchParams(location.search);
      if (params.get('courier')) radios.forEach(function (r) { if (r.value === params.get('courier')) r.checked = true; });
      if (params.get('cn')) input.value = params.get('cn').replace(/[^\w-]/g, '');
      if (!current()) radios[0].checked = true;
      showHint();

      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          showHint(); closeFrame(); msg.hidden = true;
          try { localStorage.setItem('ot-courier', r.value); } catch (e) {}
        });
      });

      form.addEventListener('submit', function () {
        var c = current();
        var num = input.value.replace(/\s+/g, '').trim();
        if (!c) { say('Please choose a courier.', true); return; }
        if (num.length < 5) { say('Please enter a valid tracking number.', true); input.focus(); return; }
        var base = c.dataset.url || '';
        if (!/^https?:\/\//i.test(base)) { say('This courier has no tracking link yet.', true); return; }

        var hasSlot = base.indexOf('{number}') > -1;
        var url = hasSlot ? base.replace(/\{number\}/g, encodeURIComponent(num)) : base;

        /* copy the number so the customer can paste it on the courier page */
        try { if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(num); } catch (x) {}

        if (c.dataset.embed === 'true' && hasSlot) {
          iframe.src = url; openLink.href = url; frameTitle.textContent = c.dataset.name + ' tracking';
          frameBox.hidden = false;
          say('Showing ' + c.dataset.name + ' tracking for ' + num + '.');
          frameBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } else {
          window.open(url, '_blank', 'noopener');
          say(hasSlot
            ? 'Opening ' + c.dataset.name + ' tracking for ' + num + '.'
            : 'Tracking number copied. On the ' + c.dataset.name + ' page, paste it into the tracking box (Ctrl+V, or long-press on mobile).');
        }
      });
    }

    function boot() { document.querySelectorAll('[data-ot-root]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking-vip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__otInit) return;
      root.__otInit = true;

      var form = root.querySelector('[data-ot-form]');
      if (!form) return;
      form.addEventListener('submit', function (e) { e.preventDefault(); });

      var input = root.querySelector('[data-ot-input]');
      var hint = root.querySelector('[data-ot-hint]');
      var msg = root.querySelector('[data-ot-msg]');
      var frameBox = root.querySelector('[data-ot-frame]');
      var iframe = root.querySelector('[data-ot-iframe]');
      var openLink = root.querySelector('[data-ot-open]');
      var frameTitle = root.querySelector('[data-ot-frame-title]');
      var radios = [].slice.call(root.querySelectorAll('input[type=radio][data-url]'));
      if (!radios.length) return;

      function current() { return radios.filter(function (r) { return r.checked; })[0]; }
      function say(t, err) { msg.hidden = false; msg.textContent = t; msg.className = 'ot-msg' + (err ? ' is-error' : ''); }
      function showHint() { var c = current(); hint.textContent = c && c.dataset.hint ? c.dataset.hint : ''; }
      function closeFrame() { frameBox.hidden = true; iframe.removeAttribute('src'); }

      /* remember the last courier; allow links like /pages/track?courier=tcs&cn=123456789 */
      try { var last = localStorage.getItem('ot-courier'); radios.forEach(function (r) { if (r.value === last) r.checked = true; }); } catch (e) {}
      var params = new URLSearchParams(location.search);
      if (params.get('courier')) radios.forEach(function (r) { if (r.value === params.get('courier')) r.checked = true; });
      if (params.get('cn')) input.value = params.get('cn').replace(/[^\w-]/g, '');
      if (!current()) radios[0].checked = true;
      showHint();

      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          showHint(); closeFrame(); msg.hidden = true;
          try { localStorage.setItem('ot-courier', r.value); } catch (e) {}
        });
      });

      form.addEventListener('submit', function () {
        var c = current();
        var num = input.value.replace(/\s+/g, '').trim();
        if (!c) { say('Please choose a courier.', true); return; }
        if (num.length < 5) { say('Please enter a valid tracking number.', true); input.focus(); return; }
        var base = c.dataset.url || '';
        if (!/^https?:\/\//i.test(base)) { say('This courier has no tracking link yet.', true); return; }

        var hasSlot = base.indexOf('{number}') > -1;
        var url = hasSlot ? base.replace(/\{number\}/g, encodeURIComponent(num)) : base;

        /* copy the number so the customer can paste it on the courier page */
        try { if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(num); } catch (x) {}

        if (c.dataset.embed === 'true' && hasSlot) {
          iframe.src = url; openLink.href = url; frameTitle.textContent = c.dataset.name + ' tracking';
          frameBox.hidden = false;
          say('Showing ' + c.dataset.name + ' tracking for ' + num + '.');
          frameBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } else {
          window.open(url, '_blank', 'noopener');
          say(hasSlot
            ? 'Opening ' + c.dataset.name + ' tracking for ' + num + '.'
            : 'Tracking number copied. On the ' + c.dataset.name + ' page, paste it into the tracking box (Ctrl+V, or long-press on mobile).');
        }
      });
    }

    function boot() { document.querySelectorAll('[data-ot-root]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
